import { Routes } from '@angular/router';
import { mustSetPasswordGuard, roleGuard } from './shared/guards/auth.guard';

/**
 * Root routing.
 *
 * - oglasnik-v3 (javni job board) lives at root: /, /jobs/:id, /apply, /login, /profile, /about, /contact
 * - /employers je landing za poslodavce (EmployersPageComponent), mediji u public/employers-assets/
 * - dashboard-v3 (interni recruiter dashboard) lives under /dashboard/*
 */
export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./oglasnik-v3/oglasnik-v3.routes').then(m => m.OGLASNIK_V3_ROUTES),
  },
  {
    path: 'dashboard',
    // Redoslijed je bitan: prvo rola, pa tek onda obveza postavljanja lozinke —
    // anonimnog šaljemo na prijavu, ne na postavljanje lozinke.
    canMatch: [roleGuard('employer', 'admin', 'subadmin'), mustSetPasswordGuard],
    loadChildren: () =>
      import('./dashboard-v3/dashboard-v3.routes').then(m => m.DASHBOARD_V3_ROUTES),
  },
  { path: '**', redirectTo: '' },
];
